import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "关于",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, FederalMinistryGermanyLogo, LinkBlock, Title} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!FederalMinistryGermanyLogo) _missingMdxReference("FederalMinistryGermanyLogo", true);
  if (!LinkBlock) _missingMdxReference("LinkBlock", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "关于"
    }), "\n", _jsx(_components.h2, {
      id: "scope",
      children: "SCOPE"
    }), "\n", _jsx(_components.p, {
      children: "SCOPE 汇集了来自教科文组织统计研究所等数据生产者的有关行政数据、住户调查、学习评估和教育资金方面的信息，以探讨在实现可持续发展目标 4 这项全球教育目标方面所取得的进展。"
    }), "\n", _jsxs(_components.p, {
      children: ["网站是对《全球教育监测报告》", _jsx(_components.a, {
        href: "https://zh.unesco.org/gem-report/allreports",
        children: "印刷版"
      }), "的补充，使用户能够与数据互动，了解各国和各地区在实现具体目标时取得的成就和面临的挑战。内容既可共享也可下载，用户可以创建图像和数据文件，以便进一步探索、打印或在线使用，或在演示中使用。"]
    }), "\n", _jsx(_components.h2, {
      id: "关于全球教育监测报告",
      children: "关于《全球教育监测报告》"
    }), "\n", _jsxs(_components.p, {
      children: ["《全球教育监测报告》是由独立团队编写并由教科文组织主办和发布的年度报告。根据《", _jsx(_components.a, {
        href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656",
        children: "2030 年教育行动框架"
      }), "》，《报告》的任务是监测关于教育的可持续发展目标的进展情况以及国家和国际教育战略的实施情况，以便于要求所有相关合作伙伴对其承诺负起责任。"]
    }), "\n", _jsx(LinkBlock, {
      title: " 访问网站",
      url: "https://zh.unesco.org/gem-report/",
      variant: "gem"
    }), "\n", _jsx(_components.h2, {
      id: "关于可持续发展目标-4",
      children: "关于可持续发展目标 4"
    }), "\n", _jsxs(_components.p, {
      children: ["2015 年 9 月，在纽约举行的联合国可持续发展问题首脑会议上，会员国正式通过了《", _jsx(_components.a, {
        href: "https://sustainabledevelopment.un.org/post2015/transformingourworld",
        children: "2030 年可持续发展议程"
      }), "》。该议程包含了 17 项可持续发展目标，其中包括可持续发展目标 4：“确保包容和公平的优质教育，让全民终身享有学习机会”。可持续发展目标 4 有七项具体目标和三种执行手段。"]
    }), "\n", _jsx(LinkBlock, {
      title: "查看具体目标和相关的监测框架",
      url: "https://sustainabledevelopment.un.org/sdg4",
      variant: "sdg4"
    }), "\n", _jsx(FederalMinistryGermanyLogo, {
      lang: "en"
    }), "\n", _jsx(_components.p, {
      children: "特别感谢德国联邦教育和研究部在开发教育进展网站方面的合作和慷慨捐助。"
    }), "\n", _jsxs(Aside, {
      children: [_jsx(_components.h2, {
        id: "联系方式",
        children: "联系方式"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "一般性电子邮件"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "mailto:gemreport@unesco.org",
          children: "gemreport@unesco.org"
        })
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "《报告》小组"
      }), _jsx(_components.p, {
        children: "《全球教育监测报告》小组，教科文组织"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "地址"
      }), _jsx(_components.p, {
        children: "Global Education Monitoring Report Team (GEM Report),\nUNESCO, 7 place de Fontenoy, 75352 Paris 07 SP, France"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
